import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { isEmpty } from 'lodash-es'

import {
  EMAIL_FOLDER_DEFAULT_VALUE,
  SUBMENU_ACCOUNT_PARAM_KEY,
  SUBMENU_PARAM_KEY,
} from '../../../../../constants/route'
import { ITEM_KEYS } from '../../EmailSubMenu.constants'
import { getSubMenuEmailsDefaultValue } from '../../EmailSubMenu.utils'

export function useDefaultEmailParams({ accountList, accountsMenu }) {
  const [searchParams, setSearchParams] = useSearchParams()

  const account = searchParams.get(SUBMENU_ACCOUNT_PARAM_KEY)

  useEffect(() => {
    if (!account && !isEmpty(accountList)) {
      const params = {
        [SUBMENU_ACCOUNT_PARAM_KEY]:
          account ||
          getSubMenuEmailsDefaultValue(accountList)[ITEM_KEYS.selectedKey],
        [SUBMENU_PARAM_KEY]:
          searchParams.get(SUBMENU_PARAM_KEY) || EMAIL_FOLDER_DEFAULT_VALUE,
      }

      setSearchParams(params, { replace: true })
    }
  }, [account, accountList])

  useEffect(() => {
    if (!isEmpty(accountsMenu) && isEmpty(accountList)) {
      setSearchParams({}, { replace: true })
    }
  }, [accountsMenu])
}
